




import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  SetupContext
} from "@vue/composition-api";

import Home from "@/components/templates/Member/Home.vue";

export default createComponent({
  components: {
    Home
  }
});
